import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    height: 50px;
    position:fixed;
    z-index: 99;
    padding: 5px 10px;
    // background-color: rgb(186, 223, 197);
    .center {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 80%;
        .rowSpace {
            justify-content: space-between;
            b {
                font-size: 15px;
            };
            p {
                font-size: 12px;
            }
        }
        .rowSameSpace {
            justify-content: space-evenly;
        }
        .rowCenter {
            justify-content: center;
        }
        svg {
            width: 2.4em;
            height: 2.4em;
        }
    }
`